var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseExpandUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6587 6.3456C12.5853 6.23902 12.4871 6.15187 12.3726 6.09166C12.258 6.03146 12.1305 6 12.0011 6C11.8717 6 11.7442 6.03146 11.6296 6.09166C11.515 6.15187 11.4168 6.23902 11.3434 6.3456L4.14287 16.7449C4.05952 16.8648 4.01065 17.0053 4.00155 17.1511C3.99245 17.2969 4.02349 17.4423 4.09128 17.5717C4.15907 17.7011 4.26102 17.8094 4.38606 17.8849C4.5111 17.9604 4.65444 18.0002 4.80052 18L19.2016 18C19.3474 17.9994 19.4902 17.9591 19.6147 17.8834C19.7393 17.8077 19.8408 17.6995 19.9084 17.5704C19.9761 17.4414 20.0072 17.2963 19.9986 17.1508C19.9899 17.0054 19.9418 16.865 19.8593 16.7449L12.6587 6.3456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseExpandUpIcon);
export default __webpack_public_path__ + "static/media/collapse-expand-up-icon.0ebcb562e7ea2f18d4cc4188d52db864.svg";
export { ForwardRef as ReactComponent };